import { type Action } from 'react-sweet-state';

import { type Product } from '../../../../common/types';
import { writeRemoteActionsMetasToLocalStorage } from '../../../remote-actions-localstore';
import { type RemoteActionsStoreState } from '../../index';

export const clearActionId =
	(actionId: string): Action<RemoteActionsStoreState, { product: Product }> =>
	({ getState, setState }, { product }) => {
		const { meta } = getState();
		const newMeta = { ...meta };
		delete newMeta[actionId];
		setState({ meta: newMeta });
		writeRemoteActionsMetasToLocalStorage(product, meta);
	};
